// REACT IMPORTS
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

// ABSOLUTE IMPORTS
import { IconWeight, SettingsV2 } from 'components/common/icons'
import KidsModeButton from 'components/common/KidsModeButton'
import { LayoutContainer } from 'ui/layout/LayoutContainer'
import type { Maybe } from 'types/hoopla'

type TopNavProps = {
  alt: string
  libraryBrandingColor?: Maybe<string>
  isFallbackNeeded: boolean
  onError: () => void
  logoUrl: string | null
  StaticHooplaLogo: FC<{ className?: string }>
}

const TopNav = ({
  alt,
  libraryBrandingColor,
  logoUrl,
  StaticHooplaLogo,
  onError,
  isFallbackNeeded,
}: TopNavProps) => {
  return (
    <section
      className="hidden bg-primary-blue-grey-light py-4 sm:block"
      style={
        libraryBrandingColor ? { backgroundColor: libraryBrandingColor } : {}
      }>
      <LayoutContainer className="animate-pulse">
        <ul aria-label="main" className="flex flex-row items-start space-x-4">
          <li className="pt-1">
            {logoUrl && !isFallbackNeeded ? (
              <img
                className="-ml-1.5 h-fit max-h-[44px] px-1.5 py-1"
                aria-hidden="true"
                src={logoUrl}
                alt={alt}
                onError={onError}
              />
            ) : (
              <StaticHooplaLogo className="-ml-1.5 block w-full" />
            )}
          </li>

          <li className="-mx-1.5 flex h-10 items-center rounded px-4 text-sm font-semibold text-slate-400">
            <FormattedMessage
              id="header.nav.browse"
              defaultMessage="Browse"
              description="label for browse link"
            />
          </li>

          <li className="focus:t -mx-1.5 flex h-10 items-center rounded text-sm font-semibold text-slate-400">
            <FormattedMessage
              id="header.nav.my.v2"
              defaultMessage="My Hoopla"
            />
          </li>

          <li className="flex-grow justify-items-end rounded pr-14">
            <div className="relative m-0 flex h-9 w-72 flex-1 rounded !border-none bg-slate-400 pl-2" />
          </li>

          <li className="pt-1 pl-1">
            <KidsModeButton className="-mx-4" />
          </li>

          <li className="pt-2 text-slate-400">
            <SettingsV2
              size={24}
              weight={IconWeight.regular}
              className="mx-2.5"
            />
          </li>
        </ul>
      </LayoutContainer>
    </section>
  )
}

export default TopNav
